import { Injectable } from '@angular/core';
import { DataService } from './core/data.service';

@Injectable({ providedIn: 'root' })
export class PedidoService extends DataService {
    context = 'pedido';

    buscarParametros(pedidos: string[], centroLogistico: string, fornecedor: string) {
        return this.getWithParams<any>(null, { pedidos, centroLogistico, fornecedor });
    }
}
